import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import persistPlugin from '@rematch/persist';
import { models, RootModel } from './RootState';
import storage from 'redux-persist/lib/storage';
import { PersistConfig } from 'redux-persist';
import { initialState as productComparisonInitialState } from './productComparisonState';
import { initialState as productGridInitialState } from './productsGridState';
import { initialState as featureInitialState } from './featureState';

const persistedStates = {
    productComparisonState: productComparisonInitialState,
    productsGridState: productGridInitialState,
    featureState: featureInitialState
};

type PersistedState = keyof typeof persistedStates;

const expiryTransform = {
    in: (state: RootState) => state,
    out: (state: RootState, key: PersistedState | unknown) => {
        if (Object.keys(persistedStates).includes(key as string)) {
            if (state.expiredAt && new Date(state.expiredAt) < new Date()) {
                return persistedStates[key as PersistedState];
            }
        }
        return state;
    }
};

const persistConfig: PersistConfig<RootModel> = {
    key: 'root',
    keyPrefix: 'bri|persist|',
    storage,
    whitelist: Object.keys(persistedStates),
    transforms: [expiryTransform]
};

const store = init({
    plugins: [persistPlugin<RootModel, RootModel>(persistConfig)],
    models
});

export default store;
export type Store = typeof store;
export type AppDispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;
